export const defaultUser = { name: "", token: "", photo: "" };
